import api from "./api";

export const register = (pseudo, email, password) =>
  api.post("/register.php", { pseudo, email, password });

export const login = async (email, password) => {
  const res = await api.post("/login.php", { email, password });
  localStorage.setItem("token", res.data.token);
  localStorage.setItem("user", JSON.stringify(res.data.user));
  return res.data.user;
};

export const logout = async () => {
  try {
    await api.post("/logout.php");
  } finally {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }
};

export const getCurrentUser = () => {
  const raw = localStorage.getItem("user");
  return raw ? JSON.parse(raw) : null;
};

export const isLoggedIn = () => !!localStorage.getItem("token");
